import api from "./api";

// 删除知识库文件
export const knowledgeItemDelete = async (itemIds: number[]) => {
  const res = await api.post<unknown>("/knowledge/delete_folder_item", {
    id: itemIds,
  });
  return res;
};
